// extracted by mini-css-extract-plugin
module.exports = {"topContainer":"MainMenuView_topContainer__2lat_","sectionBottom":"MainMenuView_sectionBottom__1eadp"};